import styled from 'styled-components';

import Icon from 'components/Icon';
import Heading from 'components/Heading';
import Paragraph from 'components/Paragraph';

export const ParagraphStyled = styled(Paragraph)`
  font-size: ${props => props.theme.font.size.small};
  margin-bottom: ${props => props.theme.spacing.medium};
  text-align: ${props => (props.alignLeft ? 'left' : 'center')};
`;

export const SectionSubTitle = styled(Heading)`
  text-align: center;
  margin-bottom: 40px;
  margin-top: ${props => props.marginTop || '16px'};
`;

export const PlansWrapper = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: ${props => props.theme.spacing.large};
  margin: ${props => props.theme.spacing.large} 0;
`;

export const PlanSection = styled.div`
  h3 {
    > span {
      float: right;
      font-size: 0.5em;
      margin-top: 10px;
      text-decoration: underline;
      cursor: pointer;
      color: ${props => props.theme.color.primary};
      transition: transform 100ms ease-in-out, text-decoration 100ms ease-in-out;
      &:hover {
        transform: scale(1.075);
        text-decoration: none;
      }
    }
  }
  > ul {
    margin-bottom: 25px;
    color: ${props => props.theme.color.wfGrey900};
    > li {
      margin-bottom: ${props => props.theme.spacing.default};
      font-size: ${props => props.theme.font.size.small};
    }
  }
  > p {
    > a {
      color: ${props => props.theme.color.primary};
      text-decoration: underline;
      cursor: pointer;
    }
    > span {
      font-weight: 400;
    }
  }
`;

export const IconStyled = styled(Icon)`
  margin-right: ${props => props.theme.spacing.small};
`;
